import {
  createStore,
  createDomain,
  Store,
  Event,
  sample,
  is
} from '@effector/effector'
import {dynamicQueueFlat} from '../batch'

export const runtimeRoot = createStore(createDomain())
//@ts-ignore
export const runtimeID: Store<string> = runtimeRoot.map(root => root.id)

export function onRuntimeEvent<T, S>({
  clock,
  target,
  filter,
  fn
}: {
  target: Store<S>
  clock: Event<T> | Store<T>
  filter: (item: T, runtimeID: string) => boolean
  fn: (state: S, updates: T[]) => S
}) {
  const sampled = sample({
    source: runtimeID,
    clock: is.store(clock) ? clock.updates : clock,
    fn: (id, value) => ({id, value}),
    greedy: true
  })
  const {processed} = dynamicQueueFlat({
    trigger: sampled,
    mark: 'onRuntimeEvent',
    fn({id, value}) {
      if (filter(value, id)) return value
    }
  })
  sample({
    source: target,
    clock: processed,
    fn,
    target
  })
}
